module.exports = __webpack_public_path__ + "images/category_lp/common/reason3-man-30@2x_79d1c3b281af21606cef04876d4e9d73.jpg";